import RangeLimits from '@scripts/components/RangeLimits';
import FormPartial from '@scripts/forms/FormPartial';
import IcrasHelpers from '@scripts/helpers';

/**
 * "Additional Biomarkers" form partial
 */
export default class extends FormPartial {

	/**
   * If the components are being refreshed
   *
   * @private
   *
   * @type {bool}
   */
  #isRefresh = false;

	/**
   * Lipopretein-A
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #lpa;

	/**
   * NT-proBNP
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #ntprobnp;

	/**
   * Hs TnT
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #hstnt;

	/**
   * uric acide level
   *
   * @private
   *
   * @type {RangeLimits}
   */
  #ual;

  constructor(form) {
    super(form);

		this.#isRefresh = false;

		this.#lpa = new RangeLimits(
      this._form.element.querySelector('#icrasLpa')
    );

		this.#ntprobnp = new RangeLimits(
      this._form.element.querySelector('#icrasNtprobnp')
    );

		this.#hstnt = new RangeLimits(
      this._form.element.querySelector('#icrasHstnt')
    );

		this.#ual = new RangeLimits(
      this._form.element.querySelector('#icrasUal')
    );
  }
 
  initialize() {
   
  }

  validate() {
    this._resetMessages();

    let errors = [];

    this.addErrors(errors);

    return super.validate();
  }

  reset() {
    super.reset();

		[this.#lpa,this.#ntprobnp,this.#hstnt,this.#ual].forEach(
      (range) => range.reset()
    );

  }
}
